import { RequestService } from '../../../../../common/services/RequestService';
import { API_TARIFF_TYPES } from '../../constants';

export const getTariffTypesRequest = payload => {
  return RequestService.get(API_TARIFF_TYPES).then(response => response);
};
